import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ 
  children, 
  requireOwner, 
  requireTechnician, 
  requireAdmin,
  requiredPermissions = [] 
}) => {
  const { 
    currentUser, 
    loading, 
    isOwner, 
    isTechnician,
    isAdmin,
    hasPermission 
  } = useAuth();
  
  const location = useLocation();
  
  if (loading) {
    // Show loading state while checking authentication
    return (
      <div className="protected-route-loading">
        <div className="loading-spinner"></div>
        <p>Verifying authentication...</p>
      </div>
    );
  }
  
  // Not logged in - redirect to login with return path
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  // Check if owner role is required but user is not owner
  if (requireOwner && !isOwner()) {
    // Redirect to unauthorized page
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Check if admin role is required but user is not admin
  if (requireAdmin && !isAdmin()) {
    // Redirect to unauthorized page
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Check if technician role is required but user is neither owner nor technician
  if (requireTechnician && !isOwner() && !isTechnician()) {
    // Redirect to unauthorized page
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Check for required permissions
  if (requiredPermissions.length > 0) {
    // Owner always has all permissions
    if (!isOwner()) {
      // Check if user has all the required permissions
      const hasAllPermissions = requiredPermissions.every(
        permission => hasPermission(permission)
      );
      
      if (!hasAllPermissions) {
        return <Navigate to="/unauthorized" replace />;
      }
    }
  }
  
  // User is authenticated and has the required role/permissions
  return children;
};

export default ProtectedRoute;